exports = module.exports = require("../../../../../../../../../../usr/lib/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".besidaMob-fileInput__root--2cNve{bottom:15px;color:#51499d;cursor:pointer;font-size:0;left:20px;overflow:hidden;position:absolute;z-index:1}.besidaMob-fileInput__icon--2QnTt,.besidaMob-fileInput__root--2cNve{height:18px;width:18px}.besidaMob-fileInput__icon--2QnTt{display:inline-block;fill:#93949c;vertical-align:middle}.besidaMob-fileInput__iuput--1wpAr{bottom:0;cursor:pointer;height:100%;left:0;opacity:0;position:absolute;right:0;top:0;width:100%}", ""]);

// exports
exports.locals = {
	"root": "besidaMob-fileInput__root--2cNve",
	"icon": "besidaMob-fileInput__icon--2QnTt",
	"iuput": "besidaMob-fileInput__iuput--1wpAr"
};